export const environment = {
  production: true,
  hmr: false,
  base_url_grid: 'https://api.wsfx.in/',
  base_url: 'https://apimerged.wsfx.in/',

  api_key: 'api-od926q416295z936kw76v1g9no952064'
};
